import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { defined } from "@formant/core/common/defined";
import { IAnnotationField } from "@formant/core/model/IAnnotationField";
import { ITaggedUsers } from "@formant/core/model/ITaggedUsers";
import { Uuid } from "@formant/core/model/Uuid";

import { userStore } from "../../stores";
import { formatUserDisplayName } from "../../utils/formatUserDisplayName";
import { MultiSelect } from "../common/MultiSelect";

export interface IEditUserAnnotationFieldProps {
    field: IAnnotationField<"user">;
    taggedUsers: ITaggedUsers;
    onChange: (taggedUsers: ITaggedUsers) => void;
    className?: string;
    bottom?: boolean;
}

@observer
export class EditUserAnnotationField extends Component<IEditUserAnnotationFieldProps> {
    public render() {
        const { onChange } = this;
        const { field, taggedUsers, className, bottom } = this.props;
        const { key } = field;

        const value = taggedUsers[key];
        const users = userStore.listAll() || [];
        const options = users
            .filter(_ => _.enabled)
            .map(_ => ({
                value: defined(_.id),
                label: formatUserDisplayName(_),
            }));

        return (
            <MultiSelect
                value={value || ""}
                options={options}
                title={field.name}
                onChange={onChange}
                bottom={bottom}
                className={classnames(className)}
            />
        );
    }

    public onChange = (value: Uuid[]): void => {
        const { field, taggedUsers, onChange } = this.props;
        const { key } = field;
        if (value.length) {
            onChange({ ...taggedUsers, [key]: value });
        } else {
            const { [key]: _, ...rest } = taggedUsers;
            onChange(rest);
        }
    };
}
